module.exports = __webpack_public_path__ + "img/galleria.cf4b70f5.png";